import React, { useEffect } from "react";
import "./assets/scss/themes.scss";
import Route from "./Routes";

import { useDispatch } from "react-redux";
import { heartbeatUser as onGetHeartbeatUser } from "../src/slices/thunks";

function App() {
  const dispatch = useDispatch();

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const userId = authUser?._id;

  useEffect(() => {
    const hideLoader = () => {
      const loader = document.getElementById("loader");
      if (loader) {
        loader.style.display = "none";
      }
    };

    requestAnimationFrame(() => {
      hideLoader();
    });
  }, []);

  useEffect(() => {
    if (!userId) return;

    const sendHeartbeat = () => {
      dispatch(onGetHeartbeatUser({ _id: userId }));
    };

    sendHeartbeat();

    const interval = setInterval(sendHeartbeat, 60000);

    return () => clearInterval(interval);
  }, [userId, dispatch]);

  return (
    <React.Fragment>
      <Route />
    </React.Fragment>
  );
}

export default App;
